import script from "./TherapyListTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TherapyListTabs.vue?vue&type=script&setup=true&lang=ts"

import "./TherapyListTabs.vue?vue&type=style&index=0&id=b554bfc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b554bfc2"]])

export default __exports__